/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { FormWrapper } from 'components/shared';

const TermsAndConditions = () => {
  return (
    <FormWrapper>
      <h2 id="terms-and-conditions--header">Terms and Conditions</h2>
      <p>
        {`I authorize West Creek Financial, Inc. dba Koalafi (“Koalafi”) to
        consider me for the range of financing options offered by this merchant,
        which may include loans, lease-to-own financing, or both. In the event
        you reside in a state that does not allow lease-to-own financing, you
        will not be considered for that financing option. I agree to and/or
        certify the following:`}
        <br />
        <br />
        <h6>Application Information:</h6>
        {`
          I certify that all information provided in this application, or in
          connection with it, is true, accurate, and complete. I understand that
          West Creek Financial, Inc. dba Koalafi (“Koalafi”) may share my application
          details, including the decision, with the merchant whose merchandise I am
          seeking to purchase. I authorize Koalafi to provide the Retailer with
          information about my application decision, as well as my application
          details and terms.
        `}
        <br />
        <br />
        {`
          I agree that I am signing this Application electronically, and that my
          electronic signature is the legal equivalent of my written signature on
          the Application.
        `}
        <br />
        <br />
        {`
          I authorize Koalafi to contact my employer to verify my employment status
          and the information provided on this Application.
        `}
        <br />
        <br />
        <h6>Credit Report:</h6>
        {`
          I authorize Koalafi to obtain information from Consumer Reporting Agencies
          (such as credit bureau reports) that we will use when considering your Application.
          You also authorize us at any time to obtain Consumer Reporting Agency reports
          and any other information or data about you for the administration, review or
          collection of your account, or extending any additional approval amounts that may
          be available to you for future leases. If you ask, we will tell you the name and
          address of the Consumer Reporting Agency from which we obtained a report about you.
        `}
        <br />
        <br />
        <h6>Bank Account/Debit Card Authorization:</h6>
        {`
          I authorize Koalafi to validate and debit recurring payments from the payment methods
          I provide. As part of the underwriting process, I understand that Koalafi will place
          an authorization hold on my debit card as previously disclosed in the application process.
          I also agree and understand that my initial payment plus applicable tax, will be due
          based on the terms of my Agreement, which may include (1) upon signing my Agreement,
          or (2) at time of delivery of items, or (3) in part upon signing my Agreement and when
          the leased property is delivered, or (4) with each rental payment. Your initial payment
          plus tax will be calculated and shown before you agree to your lease-to-own financing terms.
          If you do not sign the lease agreement, the authorization will be removed from your
          provided account and you will not be charged an initial payment. Further, in the event
          Koalafi determines I am eligible for an additional approval amount as a result of this
          Application, I authorize Koalafi to obtain future authorizations on the bank account/debit
          card provided in this Application, or otherwise provided by me to Koalafi through the
          servicing of my Account, solely for the purpose of extending additional approvals that
          may be used for future leases.  I acknowledge and understand that if Koalafi initiates
          this authorization, it will be temporary and will not result in any additional funds
          being withdrawn from my account.
        `}
        <br />
        <br />
        <h6>Texts and Communications:</h6>
        {`
          I authorize Koalafi to communicate with me regarding my account(s) through mail,
          telephone, text message, or any other legally permitted means. I agree that
          Koalafi may contact me at any phone number I provide, including mobile numbers,
          and may use an automated telephone dialing system or similar technology to do so.
          Additionally, I acknowledge that Koalafi may monitor or record conversations or
          other communications for quality and compliance purposes.
        `}
        <br />
        <br />
        <h6>Arbitration:</h6>
        {`
          I understand and acknowledge that an arbitration provision is included in the
          Agreement that I will receive if my Application is approved.
        `}
        <br />
        <br />
        {`By proceeding, I acknowledge that I have reviewed and agree to Koalafi’s
        disclosures. I understand that by proceeding I will be considered for
        the range of financing options offered by this merchant, which may include loans,
        lease-to-own financing, or both.`}
      </p>
    </FormWrapper>
  );
};

export default TermsAndConditions;
